import { render, staticRenderFns } from "./LogsTable.vue?vue&type=template&id=3a45b66c&scoped=true"
import script from "./LogsTable.vue?vue&type=script&lang=js"
export * from "./LogsTable.vue?vue&type=script&lang=js"
import style0 from "./LogsTable.vue?vue&type=style&index=0&id=3a45b66c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a45b66c",
  null
  
)

export default component.exports